import React from "react";
import { useNavigate } from "react-router-dom";
import PostsThread from "../components/PostsThread";
import TonalStatistic from "../components/TonalStatistic";


const Media: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="App">
      <div className="white-back">
        <TonalStatistic/>
        <PostsThread />
      </div>
    </div>
  );
};

export default Media;
